import AdminLayout from "@/components/AdminLayout";
import FileManager from "@/components/FileManager";

export default function Accounts() {
  return (
    <AdminLayout title="ACCOUNTS">
      <FileManager
        section="accounts"
        allowedExtensions={[".txt"]}
        canCreateText={true}
      />
    </AdminLayout>
  );
}
